import { render, staticRenderFns } from "./OptionBox.vue?vue&type=template&id=ccc1e288&scoped=true&"
import script from "./OptionBox.vue?vue&type=script&lang=js&"
export * from "./OptionBox.vue?vue&type=script&lang=js&"
import style0 from "./OptionBox.vue?vue&type=style&index=0&id=ccc1e288&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc1e288",
  null
  
)

export default component.exports